import React from 'react';
import { LockIcon, ShieldCheckIcon, CreditCardIcon, DownloadIcon } from 'lucide-react';
import { MarketSelector } from './MarketSelector';
const seals = [{
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: CreditCardIcon,
  label: 'Tarjeta y billeteras digitales'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: DownloadIcon,
  label: 'Acceso digital inmediato'
}];
export function Footer() {
  return <footer className="w-full bg-navy py-10 pb-28 md:pb-10" data-id="element-111" data-mp="3ugbqx8rpngjv">
      <div className="mx-auto flex max-w-content flex-col items-center gap-5 px-5 text-center sm:px-8" data-id="element-112" data-mp="38h456i9zcjd">
        <p className="font-display text-sm font-extrabold uppercase tracking-[0.18em] text-white" data-id="element-113" data-mp="3levgj10wbefn">
          El Gran Reto Creativo
        </p>

        <MarketSelector tone="dark" id="market-selector-footer" data-id="element-114" data-mp="3qbvqhn0v91c1" />

        <ul className="flex flex-wrap items-center justify-center gap-x-5 gap-y-3" data-id="element-115" data-mp="29yxc5agnxgkr">
          {seals.map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex items-center gap-2" data-id="element-116" data-mp="2ezl541ogc7hm">
              <Icon className="h-4 w-4 text-sun" aria-hidden="true" data-id="element-117" data-mp="3lalgthavm9v0" />
              <span className="font-sans text-xs text-white/70" data-id="element-118" data-mp="3gapbneqg0cdv">{label}</span>
            </li>)}
        </ul>

        <p className="max-w-xl font-sans text-[11px] leading-relaxed text-white/40" data-id="element-119" data-mp="3v7zwvfsw0wms">
          Producto 100% digital. El precio y la moneda corresponden a tu país y coinciden
          con el checkout.
        </p>
      </div>
    </footer>;
}